module.exports = __webpack_public_path__ + "img/g-pm25.e8487015.png";